var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10091 10.8633L9.10091 0.829102",
    stroke: "#EE4360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 8.42383L9.10125 10.8638L6.67125 8.42383",
    stroke: "#EE4360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9611 4.77344H13.7386C15.4344 4.77344 16.8086 6.1476 16.8086 7.84427V11.9143C16.8086 13.6059 15.4378 14.9768 13.7461 14.9768L4.46276 14.9768C2.76693 14.9768 1.39193 13.6018 1.39193 11.9059L1.39193 7.8351C1.39193 6.14427 2.76359 4.77344 4.45443 4.77344L5.23943 4.77344",
    stroke: "#EE4360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.81589958a6a95c48df7d7c5f84dbc626.svg";
export { ForwardRef as ReactComponent };